module.exports = __webpack_public_path__ + "img/logo.f0600e6a.png";